/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAccountsTraitDTO
 */
export interface ServiceAccountsTraitDTO {
    /**
     * 
     * @type {number}
     * @memberof ServiceAccountsTraitDTO
     */
    serviceAccountsLimit: number;
}

/**
 * Check if a given object implements the ServiceAccountsTraitDTO interface.
 */
export function instanceOfServiceAccountsTraitDTO(value: object): value is ServiceAccountsTraitDTO {
    if (!('serviceAccountsLimit' in value) || value['serviceAccountsLimit'] === undefined) return false;
    return true;
}

export function ServiceAccountsTraitDTOFromJSON(json: any): ServiceAccountsTraitDTO {
    return ServiceAccountsTraitDTOFromJSONTyped(json, false);
}

export function ServiceAccountsTraitDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAccountsTraitDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceAccountsLimit': json['serviceAccountsLimit'],
    };
}

export function ServiceAccountsTraitDTOToJSON(value?: ServiceAccountsTraitDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'serviceAccountsLimit': value['serviceAccountsLimit'],
    };
}

